import { mutationOptions } from '../../common/utils';
import { paymentAPIClient } from '../paymentAPIClient';
import type { CreatePaymentIntentRequest, UpdatePaymentIntentRequest } from './types';

export const PAYMENT_MUTATIONS = {
  createPaymentIntent: () =>
    mutationOptions({
      mutationFn: (params: CreatePaymentIntentRequest) => paymentAPIClient.createPaymentIntent(params),
    }),
  updatePaymentIntent: () =>
    mutationOptions({
      mutationFn: (params: UpdatePaymentIntentRequest) => paymentAPIClient.updatePaymentIntent(params),
    }),
};
